/* ============================================================
   MOTORFEST · Road to Motorfest — JS de la sección
   Archivo: assets/motorfest-road.js
   Dibuja la ruta, anima el trazo recorrido y desplaza un ícono
   de auto hasta el punto de avance actual.
   ============================================================ */

function mfInitRoadTrack(track) {
  if (!track || track.dataset.mfBuilt === '1') return;
  track.dataset.mfBuilt = '1';

  var svg = track.querySelector('svg');
  var fillPath = track.querySelector('.mf-road__fill-path');
  var car = track.querySelector('.mf-road__car');
  var nodes = track.querySelectorAll('.mf-road__node');
  var labels = track.querySelectorAll('.mf-road__label');
  if (!svg || !fillPath) return;

  var vb = svg.viewBox.baseVal;
  var progress = parseFloat(track.dataset.progress || '0.07');

  function place(el) {
    var x = parseFloat(el.dataset.x), y = parseFloat(el.dataset.y);
    el.style.left = (x / vb.width * 100) + '%';
    el.style.top = (y / vb.height * 100) + '%';
  }
  nodes.forEach(place);
  labels.forEach(place);

  var totalLen = fillPath.getTotalLength();
  fillPath.style.strokeDasharray = totalLen;
  fillPath.style.strokeDashoffset = totalLen;

  function animate() {
    var start = null;
    var duration = 1700;
    function step(ts) {
      if (!start) start = ts;
      var t = Math.min(1, (ts - start) / duration);
      var eased = 1 - Math.pow(1 - t, 3);
      var currentProgress = progress * eased;
      fillPath.style.strokeDashoffset = totalLen * (1 - currentProgress);
      var pt = fillPath.getPointAtLength(totalLen * currentProgress);
      car.style.left = (pt.x / vb.width * 100) + '%';
      car.style.top = (pt.y / vb.height * 100) + '%';
      car.classList.add('is-active');
      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        car.classList.add('mf-arrived');
      }
    }
    requestAnimationFrame(step);

    nodes.forEach(function (n, i) { setTimeout(function () { n.classList.add('mf-in'); }, 120 * i); });
    labels.forEach(function (l, i) { setTimeout(function () { l.classList.add('mf-in'); }, 120 * i); });
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        animate();
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.35 });
  io.observe(track);
}

function mfInitRoad(context) {
  var scope = context || document;
  var sections = scope.classList && scope.classList.contains('mf-road')
    ? [scope]
    : scope.querySelectorAll('.mf-road');

  sections.forEach(function (section) {
    section.querySelectorAll('.mf-road__track').forEach(mfInitRoadTrack);
  });
}

document.addEventListener('DOMContentLoaded', function () {
  mfInitRoad(document);
});

// Compatibilidad con el editor de temas de Shopify (vista previa en vivo)
document.addEventListener('shopify:section:load', function (event) {
  mfInitRoad(event.target);
});